import Call from '../Call';

const BidderSourcesBlock = {
    get(name) {
        return Call(`bidderSourcesBlock/${name}`);
    },

    save(name, feed, affids) {
        return Call(`bidderSourcesBlock/${name}`,'POST', { feed, affids });
    },

    remove(id) {
        return Call(`bidderSourcesBlock/${id}`,'DELETE');
    },

    removeAll(name) {
        return Call(`bidderSourcesBlock/all/${name}`,'DELETE');
    }
};

export default BidderSourcesBlock;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderSourcesBlock.js